import { useContext } from "react";
import { BalanceContext} from "@/src/context";

export const useBalances = () => useContext(BalanceContext);